import type { RouteDefinition } from "../../routes/routes";
import SellerPerformance from "./Dashboard";

export const SellerPerformanceRoutes: RouteDefinition[] = [
  {
    path: "/seller",
    layout: "/user",
    application: "Pricing",
    children: [
      {
        path: "/user/seller/performance",
        component: SellerPerformance,
        exact: true,
      },
    ],
  },
];
